// Single source of truth for external links and store info.
// Update UBER_EATS_URL when the actual shop endpoint becomes available.

export const UBER_EATS_URL = "https://www.order.store/store/smashed-burger-%26-bao-boy/Wqf-3cn0X1y3O-dqUZCDrA";

export const STORE = {
  name: "Smashed Burger & Bao Boy",
  address_line1: "172 Portland Rd",
  address_line2: "Brighton and Hove, Hove BN3 5QN",
  postcode: "BN3 5QN",
  phone: "01273 775335",
  phone_tel: "tel:+441273775335",
  service: "Take-away Only",
  hours_summary: "Tuesday – Monday: 12:00pm – 1:00am",
  hours_detail: [
    { day: "Tuesday", time: "12:00pm – 1:00am" },
    { day: "Wednesday", time: "12:00pm – 1:00am" },
    { day: "Thursday", time: "12:00pm – 1:00am" },
    { day: "Friday", time: "12:00pm – 1:00am" },
    { day: "Saturday", time: "12:00pm – 1:00am" },
    { day: "Sunday", time: "12:00pm – 1:00am" },
    { day: "Monday", time: "12:00pm – 1:00am" },
  ],
  // Google Maps query link for the address
  maps_url: "https://www.google.com/maps/search/?api=1&query=172+Portland+Rd+Hove+BN3+5QN",
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_smashed-delivery/artifacts/yk6wb7db_Logo.png";
